<template>
    <template v-if="divItem.divisionName !== ''">
        <div class="d-flex align-items-center"
             style="height: 32px;">
            <template v-if="isInheritance===true">
                <template v-if="isViewable">
                    <div v-bind:class="CreateIconFontText()" style="margin-left: 4px; ">
                        <i v-bind:class="CreateIconTypeText()"></i>
                    </div>
                </template>
                <template v-else>
                    <img src="../../assets/img/pc_color_restricted.svg" class="division-icon">
                </template>
            </template>
            <template v-else>
                <img :src="divisionIcon" class="division-icon">
            </template>
            <div v-bind:class="CreateClassText()"
                 style="margin-left: 4px">
                <span>{{divItem.divisionName}}</span>
            </div>
            <template v-if="0 < divItem.alertAgentCount">
                <div class="d-flex flex-row align-items-center">
                    <div style="width: 8px;"></div>
                    <img src="../../assets/img/alert_color.svg" height="20">
                    <div style="width: 4px;"></div>
                    <span class="alert-agent-count-text">
                        {{divItem.alertAgentCount}}
                    </span>
                </div>
            </template>

            <!-- 常に表示したいとき、このslotを使用して下さい -->
            <slot :name="'label'+ divItem.divisionId"></slot>

            <!-- 閲覧可能 & 無効な部署でないときのみ表示したいとき、このslotを使用して下さい -->
            <slot v-if="isEnable()" :name="'enable'+ divItem.divisionId"></slot>
        </div>
    </template>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { DivisionData } from "@/models/DivisionData"
import groupCheckIcon from "@/assets/img/pc_group_color_clear.svg";
import groupDisabledIcon from "@/assets/img/pc_group_color_disabled.svg";
import groupIcon from "@/assets/img/pc_group_color.svg";
import groupRestrictedIcon from "@/assets/img/pc_group_color_restricted.svg";

interface Props {
    // (必須)部署ツリー
    divItem: DivisionData;
    // (オプション)無効状態にする部署
    disableDivisionIds?: Set<number>;
    // (オプション)有効な部署にチェックアイコンを表示する
    isShowCheckIconEnableDivision?: boolean;
    // (オプション)アイコン情報
    strDivisionIcon?: string;
    // (オプション)継承ツリーかどうか
    isInheritance?: boolean;
    // (必須)閲覧可能か
    isViewable: boolean;
}
const props = withDefaults(defineProps<Props>(), {
    disableDivisionIds: () => new Set<number>(),
    isShowCheckIconEnableDivision: false,
    strDivisionIcon: "",
    isInheritance: false,
});

// アイコンカラーの指定
function CreateIconFontText(): string {
    return props.strDivisionIcon.replace("-inherit", "");
}

// アイコンの指定
function CreateIconTypeText(): string {
    if (props.strDivisionIcon.match("-inherit")) {
        return "icon-pc_inherit";
    }

    return "icon-pc_individual";
}

// クラス文字列の作成
function CreateClassText(): string {
    // 色
    // 無効オプション
    if (props.disableDivisionIds.has(props.divItem.divisionId) || !props.isViewable) {
        return "disableText";
    }
    // アラート端末あり
    else if (0 < props.divItem.alertAgentCount) {
        return "alertText";
    }

    return "";
}

/**
* 有効状態を取得します。
*/
function isEnable(): boolean {
    return props.isViewable && !props.disableDivisionIds.has(props.divItem.divisionId)
}

/**
* チェックアイコン付きの部署を表示するかを取得します。
*/
function isShowCheckIcon(): boolean {
    if (!props.isShowCheckIconEnableDivision) {
        return false;
    }
    // 有効な部署にはチェックアイコン付きの部署アイコンを表示する
    return !props.disableDivisionIds.has(props.divItem.divisionId);
}

/**
* 部署アイコンを取得します。
*/
const divisionIcon = computed(() => {
    if (isShowCheckIcon()) {
        return groupCheckIcon;
    }
    if (props.disableDivisionIds.has(props.divItem.divisionId)) {
        return groupDisabledIcon;
    }

    if (props.isViewable) {
        return groupIcon;
    }
    else {
        return groupRestrictedIcon;
    }
});
</script>

<style scoped>

    /* ツリーテキスト（無効） */
    .disableText {
        color: rgba(24,24,24,0.3);
    }

    /* ツリーテキスト（アラート） */
    .alertText {
        color: #DE4747;
    }

    /* 連続スペース可 */
    span {
        white-space: pre;
    }

    /* テキスト（アラート端末の数） */
    .alert-agent-count-text {
        color: #242424;
        font-size: 12px;
    }

    /* 部署アイコン */
    .division-icon {
        margin-left: 4px;
        width: 24px;
        height: 24px;
    }
</style>
